import { FaLongArrowAltRight } from "react-icons/fa";

import classes from './DepartmentsTreeNode.module.scss';
import {Badge} from "antd";

const isForMobile = window.innerWidth < 801;

const DepartmentsTreeNode = (props) => {

    let departmentCode = props.data.code + ' - '
    let departmentName
    let departmentAbbrev
    if (props.searchMatch !== '' && props.data.name.toUpperCase().includes(props.searchMatch.toUpperCase())) {
        const parts = props.data.name.split(new RegExp(`(${props.searchMatch})`, 'gi'))
        departmentName = parts.map((part, index) => part.toUpperCase() === props.searchMatch.toUpperCase() ? <span key={index} className={classes.matchStr}>{part}</span> : part)
    } else departmentName = props.data.name
    if (props.searchMatch !== '' && props.data.abbrev.toUpperCase().includes(props.searchMatch.toUpperCase())) {
        departmentAbbrev = '(' + props.data.abbrev + ')'
        const parts = departmentAbbrev.split(new RegExp(`(${props.searchMatch})`, 'gi'))
        departmentAbbrev = parts.map((part, index) => part.toUpperCase() === props.searchMatch.toUpperCase() ? <span key={index} className={classes.matchStr}>{part}</span> : part)
    } else departmentAbbrev = '(' + props.data.abbrev + ')'

    let selectedDepartmentStyle = !isForMobile && props.selectedDepartmentId && props.selectedDepartmentId === props.data.id ? classes.selectedDepartment : null

    return (
        (props.data.employees.length !== 0)
            ? <div className={`${classes.nodeDetails} DepartmentsTreeNode_color ${selectedDepartmentStyle}`}
                   style={{width: `${90 - props.level * 10}%`}}
                   onClick={() => props.setSelectedDepartment(props.data.id, props.matchingEmployeeCount !== 0)}>
                <div className={classes.nodeDetailsText}>
                    {departmentCode}
                    <span style={{fontWeight: '700', color: '#3A547F'}}>{departmentName}</span> {departmentAbbrev}
                </div>
                <div className={`${classes.numberOfEmployee} DepartmentsTreeNode_numberOfEmployee_color`}>
                    {props.matchingEmployeeCount !== 0
                        ? <Badge count={props.matchingEmployeeCount} color={'#ff9632'} size={'small'} offset={[8, -2]}>
                            {props.data.employees.length}
                        </Badge>
                        : props.data.employees.length}
                </div>
                <div className={classes.departmentDetailsLink}>
                    <FaLongArrowAltRight size={15}/>
                </div>
            </div>
            : <div className={`${classes.nodeDetails} DepartmentsTreeNode_color`}
                   style={{width: `${90 - props.level * 10}%`}}>
                <div className={classes.nodeDetailsText}>
                    {departmentCode}
                    <span style={{fontWeight: '700', color: '#3A547F'}}>{departmentName}</span> {departmentAbbrev}
                </div>
            </div>
    )
}

export default DepartmentsTreeNode;